
export const getCDPAltText = ({year = "", make = "", model = "", variant = "", transmissionType = "", odometerReading = ""}) => {
    return `${year} ${make} ${model} ${variant}, ${transmissionType}, ${odometerReading} km`;
};
